import { useEffect, useState } from 'react'

/** `true` enquanto a media query bate. SSR-safe (assume `false` sem window). */
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return false
    return window.matchMedia(query).matches
  })

  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return
    const mql = window.matchMedia(query)
    const handler = (event: MediaQueryListEvent) => setMatches(event.matches)
    setMatches(mql.matches)
    mql.addEventListener('change', handler)
    return () => mql.removeEventListener('change', handler)
  }, [query])

  return matches
}

/** Atalho: telas a partir de `lg` (1024px) do Tailwind. */
export function useIsDesktop(): boolean {
  return useMediaQuery('(min-width: 1024px)')
}
